define('viewModels/privileged/qm/util/ConversationTimelineUtil',[
    'lib/knockout',
    'lib/lodash4'
], function(ko, _) {
    'use strict';

     function getParticipantGroup(participant, interaction, communicationType) {
        var id = participant.participantId;
        var userId = participant.userId;
        var type = getParticipantPurpose(participant);
        var direction = interaction.direction;

        if (participant.userId) {
            // This is a user, so only Inbound or Outbound
            return userId + "_" + direction + "_" + type + "_" + communicationType;
        } else if (participant.queueId) {
            return participant.queueId + "_" + type + "_" + communicationType;
        } else {
            return id + "_" + type + "_" + communicationType;
        }
    }

    function getParticipantPurpose(participant) {
        return (participant.purpose || "unknown").toLowerCase();
    }

    var guidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    function isGuid(maybeGuid) {
        return guidPattern.test(maybeGuid);
    }

    function getParticipantName(participant) {
        if (!participant.participantName &&
                (participant.purpose === "agent" ||
                 participant.purpose === "user" ||
                 participant.purpose === "customer" ||
                 participant.purpose === "external")) {
            return ko.i18n.renderString('conversationTimeline.participantInfo.noName');
        } else if (participant.purpose === "voicemail" && isGuid(participant.participantName)) {
            // Voicemail participants have a guid name sometimes. Hide it.
            return "";
        }
        return participant.participantName;
    }

    function isConversationActive(conversation) {
        var sessions = _.flatMap(conversation.participants, 'sessions');
        return _.some(sessions, {'state': 'connected'});
    }

    function roundMillisecondsToNearestSecond(value) {
        return Math.round(value/1000)*1000;
    }

    return {
        getParticipantGroup: getParticipantGroup,
        getParticipantPurpose: getParticipantPurpose,
        getParticipantName: getParticipantName,
        isConversationActive: isConversationActive,
        roundMillisecondsToNearestSecond: roundMillisecondsToNearestSecond
    };

});

